import React from 'react';
import styles from "./event_box.module.scss";

export const EventBox = (props) => {
    const {event_image, event_title, event_time} = props.data;
    return (
        <div className={styles.event}>
            <div className={styles.event_image}>
                <img src={event_image} alt={event_title} />
            </div>
            <div className={styles.event_content}>
                <p className={styles.event_content_meta}>{event_time}</p>
                <h2 className={styles.event_content_title}>{event_title}</h2>
            </div>
        </div>
    )
}

export default EventBox;